import axios from '../../axios';
import * as types from './mutation-types'
const state = () => ({
	news: ''
})
const actions = {
	fetchNews({ commit }) {
		return axios.get('/news').then(response => commit(types.STORE_NEWS, response.data))
	}
}
const mutations = {
	[types.STORE_NEWS](state, news) {
		state.news = news;
	}
}
export default {
	namespaced: true,
	state,
	actions,
	mutations
}
